import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const SessionConflictModal = ({ show, onTakeover, onCancel }) => {
  return (
    <Modal 
      show={show} 
      backdrop="static" 
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Header style={{ borderBottom: '2px solid #810055' }}>
        <Modal.Title style={{ fontFamily: "'G&B-Headline', sans-serif", color: '#810055' }}>
          Active Session Detected
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '1.5rem' }}>
        <div style={{
          backgroundColor: '#F9F2F6',
          border: '1px solid #810055',
          borderRadius: '6px',
          padding: '1rem 1.25rem',
          color: '#810055',
          fontFamily: "'G&B-BodyCopy', sans-serif",
          fontSize: '0.95rem',
          lineHeight: '1.5'
        }}>
          Your account is already active on another device or browser. 
          If you continue here, that session will be logged out.
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: '1px solid #F1F1ED' }}>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onTakeover}>
          Continue Here
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionConflictModal;
